<div #panel class="panel-box top scrollbar-custom" [ngClass]="configObj?.position" cdkDragBoundary=".main-content"
    cdkDrag>
    <div cdkDragHandle class="header">
        <div #toggleArrow class="arrow down" [ngClass]="{'down': toggle, 'up': !toggle}" (click)="onClick()"></div>
    </div>
    <div class="title" (click)="onClick()" [ngClass]="{'box-shadow': !toggle}">
        <div class="text-title">{{configObj?.title | translate}}</div>
        <div class="item-selected" *ngIf="!toggle">
            <ng-container *ngTemplateOutlet="itemSelectedTemplate"></ng-container>
        </div>
    </div>
    <div class="body">
      <div class="mt-2"></div>
        <ng-container *ngTemplateOutlet="bodyTemplate"></ng-container>
    </div>
</div>